import React from 'react';
import { Link, useLocation } from 'react-router-dom';

type Destination = { path: string; label: string; group: string };
const primary: Destination[] = [
  { path: '/', label: 'Racing', group: 'racing' },
  { path: '/sports/afl', label: 'Sports', group: 'sports' },
  { path: '/strategy', label: 'Claude', group: 'claude' },
  { path: '/strategy/brain', label: 'Staking Brain', group: 'brain' },
  { path: '/strategy/bucket-bets', label: 'Bet Buckets', group: 'buckets' },
  { path: '/strategy/auto', label: 'Auto', group: 'auto' },
  { path: '/strategy/external-intelligence', label: 'External Intel', group: 'intel' },
  { path: '/reports', label: 'Reports', group: 'reports' },
  { path: '/my-bets', label: 'My Bets', group: 'bets' },
  { path: '/tools', label: 'Tools', group: 'tools' },
];
export function navigationGroup(path: string): string {
  if (path === '/sports' || path.startsWith('/sports/')) return 'sports';
  if (path === '/strategy') return 'claude';
  if (path === '/strategy/brain') return 'brain';
  if (path === '/strategy/bucket-bets' || path === '/strategy/buckets') return 'buckets';
  if (path === '/strategy/auto') return 'auto';
  if (path === '/strategy/external-intelligence') return 'intel';
  if (path === '/reports' || path === '/strategy/results') return 'reports';
  if (path === '/my-bets') return 'bets';
  if (path === '/' || /^\/(race\/|horse\/|results|next-to-jump|futures)/.test(path)) return 'racing';
  return 'tools';
}
export default function ProjectNavigation({ open, close, admin, sectionOnly = false, paperReviewer = false }: { open: boolean; close: () => void; admin: boolean; sectionOnly?: boolean; paperReviewer?: boolean }) {
  const { pathname } = useLocation();
  const group = navigationGroup(pathname);
  if (paperReviewer) return sectionOnly ? null : <nav id="main-navigation" className={'header-nav' + (open ? ' nav-open' : '')} aria-label="Paper navigation" onClick={close}>
    {[[ '/', 'Racing'], ['/sports/nrl', 'Sports'], ['/strategy/auto', 'Auto'], ['/strategy/bucket-bets', 'Bet Buckets'], ['/my-bets', 'My Bets']].map(([path,label])=><Link key={path} to={path} className={'nav-item' + (pathname===path?' active':'')} aria-current={pathname===path?'page':undefined}>{label}</Link>)}
  </nav>;
  const secondary: { path: string; label: string }[] = group === 'racing' ? [
    { path: '/', label: 'Meetings' }, { path: '/next-to-jump', label: 'Next to jump' },
    { path: '/results', label: 'Latest results' }, { path: '/results/day', label: 'Results by day' },
    { path: '/futures', label: 'Upcoming meetings' },
  ] : group === 'sports' ? [{path:'/sports/afl',label:'AFL'},{path:'/sports/nrl',label:'NRL'},{path:'/sports/nba',label:'NBA'}] : group === 'tools' ? [
    { path: '/tools', label: 'All tools' }, { path: '/strategy/inspection', label: 'Model inspection' },
    { path: '/tools/archive', label: 'Archive' }, { path: '/betfair', label: 'Account connection' },
    ...(admin ? [{ path: '/all-notes', label: 'Voice notes' }, { path: '/review', label: 'Review queue' },
      { path: '/settings', label: 'Settings' }, { path: '/users', label: 'Users' }] : []),
  ] : group === 'reports' ? [
    { path: '/reports', label: 'Report sources' }, { path: '/reports/jockeys', label: 'Jockey performance' }, { path: '/strategy/results', label: 'Strategy history' },
    { path: '/strategy/bucket-bets', label: 'Bucket history' }, { path: '/strategy/brain', label: 'Brain paper results' },
    { path: '/my-bets', label: 'Account history' },
  ] : [];
  return <>
    {!sectionOnly && <nav id="main-navigation" className={'header-nav' + (open ? ' nav-open' : '')} aria-label="Main navigation" onClick={close}>
      {primary.map(item => <Link key={item.path} to={item.path}
        className={'nav-item' + (group === item.group ? ' active' : '')}
        aria-current={group === item.group ? 'page' : undefined}>{item.label}</Link>)}
    </nav>}
    {sectionOnly && secondary.length > 0 && <nav className="project-subnav" aria-label="Section navigation">
      {secondary.map(item => <Link key={item.path} to={item.path} onClick={close}
        className={pathname === item.path ? 'active' : ''}
        aria-current={pathname === item.path ? 'page' : undefined}>{item.label}</Link>)}
    </nav>}
  </>;
}
